import React, { useState, useEffect } from 'react';
import { useUserProfile } from '../helper/UserProfile';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import '../stylesheets/navigation.scss';
import '../index.scss'

function Navigation() {

    const location = useLocation();
    const [member, setMember] = useState("");
    const [instructor, setInstructor] = useState("");
    const { profile } = useUserProfile();

    const isRevalidationActive = location.pathname.startsWith("/dashboard/revalidation");

    useEffect(() => {
    if (profile && profile.revalidation_membership !== undefined) {
        setMember(profile.revalidation_membership);
        setInstructor(profile.instructor_approval);
        }
    }, [profile]);
    

    return (
    
    <div className="navigation">
        <ul>
            <li className={location.pathname === "/dashboard" ? "active" : ""}><Link to="/dashboard" className={location.pathname === "/dashboard" ? "active" : ""}>DASHBOARD</Link></li>


            {/*<li className={location.pathname === "/dashboard/signup" ||location.pathname === "/dashboard/courses" ? "active" : ""}><Link to={instructor === false ? "/dashboard/pendingApproval" : "/dashboard/courses"} className={location.pathname === "/dashboard/pendingApproval" ? "active" : ""}>COURSES  {instructor === false && (<FontAwesomeIcon icon={faLock} style={{color: "#1a1a1a"}} className="icon"/>)}</Link></li>*/}


            <li className={location.pathname === "/dashboard/signup" ||location.pathname === "/dashboard/revalidation" ? "active" : ""}><Link to={member === false ? "/dashboard/signup" : "/dashboard/revalidation"} className={location.pathname === "/dashboard/signup" ||isRevalidationActive ? "active" : ""}>REVALIDATION PORTAL  {member === false && (<FontAwesomeIcon icon={faLock} style={{color: "#1a1a1a"}} className="icon"/>)}</Link>

                {isRevalidationActive && (
                <ul id="revalidation-sublist">
                    <li className={location.pathname === "/dashboard/revalidation" ? "active" : ""}><Link to="/dashboard/revalidation" className={location.pathname === "/dashboard/revalidation" ? "active" : ""}>Home</Link></li>

                    <li className={location.pathname === '/dashboard/revalidationDocuments' ? "active " : ""}><Link to="/dashboard/revalidationDocuments" className={location.pathname === '/dashboard/revalidationDocuments' ? "active " : ""}>Documents</Link></li>

                    {isRevalidationActive && (
                        <ul id="reval-doc-sublist">
                            <li className={location.pathname === "/dashboard/revalidationCPD" ? "active" : ""}><Link to="/dashboard/revalidationCPD" className={location.pathname === "/dashboard/revalidationCPD" ? "active" : ""}>CPD</Link></li>
                            <li className={location.pathname === "/dashboard/revalidationPHL" ? "active" : ""}><Link to="/dashboard/revalidationPHL" className={location.pathname === "/dashboard/revalidationPHL" ? "active" : ""}>PHL</Link></li>
                            <li className={location.pathname === "/dashboard/revalidationReflectiveAccount" ? "active" : ""}><Link to="/dashboard/revalidationReflectiveAccount" className={location.pathname === "/dashboard/revalidationReflectiveAccount" ? "active" : ""}>Reflective Accounts</Link></li>
                            <li className={location.pathname === "/dashboard/revalidationFeedback" ? "active" : ""}><Link to="/dashboard/revalidationFeedback" className={location.pathname === "/dashboard/revalidationFeedback" ? "active" : ""}>Practice Feedback</Link></li>

                            <li className={profile.reval_members.membership_tier === "Gold" ? "hide" : location.pathname === "/dashboard/revalidationConfirmation" ? "active" : ""}><Link to="/dashboard/revalidationConfirmation" className={location.pathname === "/dashboard/revalidationConfirmation" ? "active" : ""}>Confirmation Documents</Link></li>
                        </ul>
                    )}
                </ul>
                )}
            </li>

            <li className={location.pathname === "/dashboard/support" ? "active" : ""}><Link to="/dashboard/support" className={location.pathname === "/dashboard/support" ? "active" : ""}>SUPPORT</Link></li>
        </ul>
    </div>
  )
}

export default Navigation